











































































































































































































































































































































































import axios from 'axios';
import { get, uniqBy, uniqueId, filter, orderBy } from 'lodash';

import CoPrice from '@/components/Atoms/co-price/coPrice.vue';
import CoImage from '../../Atoms/co-image/CoImage.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoButton from '../../Atoms/co-button/CoButton.vue';
import CoHeadline from '../../Atoms/co-headline/CoHeadline.vue';
import CoSkeleton from '../../Atoms/co-skeleton/CoSkeleton.vue';
import CoThumbnail from '../co-thumbnail/CoThumbnail.vue';
import CoDate from '../co-date/CoDate.vue';
import CoPill from '../../Atoms/co-pill/CoPill.vue';
import CoPeople from '../co-people/CoPeople.vue';

import { Event, User } from '../../../types/GlobalTypes.ts';

export default {
    components: {
        CoSkeleton,
        CoHeadline,
        CoButton,
        CoText,
        CoImage,
        CoThumbnail,
        CoDate,
        CoPill,
        CoPeople,
        CoPrice,
    },
    name: 'CoEvent',
    props: {
        event: {
            type: Object as () => Event,
            required: true,
            default: () => ({}),
        },
        variant: {
            type: String,
            validator: (value: string) => ['default', 'micro', 'list', 'full'].includes(value),
            default: 'default',
            required: false,
        },
        loading: {
            type: Boolean,
            default: false,
            required: false,
        },
        me: {
            type: Object,
            required: false,
        },
        link: {
            type: Boolean,
            required: false,
            default: true,
        },
        forceMobileLayout: {
            type: Boolean,
            required: false,
            default: false,
        },
        spaceTermsAndConditions: {
            type: String,
            required: false,
            default: '',
        },
        isPublic: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            meLocal: get(this, 'me', null) || {
                ...get(this.$store, 'state.me', {}),
                ...get(this.$store, 'state.me.Profile', {}),
            },
            amIattending: false,
            amIorganising: false,
            currency: get(this.$store, 'state.space.Currency', null),
        };
    },
    computed: {
        isEventPast() {
            return this.event.EndDate < new Date().getTime() / 1000;
        },
        // Reuse the existing mobile layout branch when full cards must stay compact on larger viewports.
        useMobileFullLayout() {
            return this.variant === 'full' && this.forceMobileLayout;
        },
        participantList() {
            const creator = this.event?.CreatedByProfile;
            const organizers = this.event?.OrganizersProfiles;
            const participants = this.event?.ParticipantProfiles;
            const allUsers = [];
            if (creator && creator.ID) {
                allUsers.push(creator);
            }
            if (organizers && organizers.length > 0) {
                allUsers.push(...organizers);
            }
            if (participants && participants.length > 0) {
                allUsers.push(...participants);
            }
            // filter out duplicates
            const uniqueUsers = uniqBy(allUsers, 'ID');
            return uniqueUsers;
        },
        amILoggedIn() {
            return this.meLocal.ID;
        },
        priceRange() {
            if (!this.event?.Tickets || this.event.Tickets.length === 0) return null;
            // filter out tickets that are deleted
            const tickets = filter(this.event.Tickets, (e) => !e.Deleted);
            //
            const prices = orderBy(
                tickets.map((ticket) => ({
                    PriceInCents: 0, // make sure free tickets are also shown
                    ...ticket, // if PriceInCents is set, it will override the 0 above
                })),
                ['PriceInCents'],
                ['asc']
            ).map((ticket) => ({
                ...ticket,
                Currency: this.currency || '',
            }));
            return prices;
        },
        taxRates() {
            if (!this.event?.Tickets || this.event.Tickets.length === 0) return [];
            // filter out tickets that are deleted
            const tickets = filter(this.event.Tickets, (e) => !e.Deleted);
            return uniqBy(
                tickets.map((ticket) => ticket.TaxRate).filter((taxRate) => taxRate),
                'ID'
            );
        },
        hideFreeLabel() {
            return (
                this.event &&
                this.event.FullURL &&
                this.event.FullURL.length > 3 &&
                (!this.event.Tickets || this.event.Tickets.length < 1)
            );
        },
        eventTypes() {
            // get array of capitalized type names
            if (this.event?.Types && Array.isArray(this.event.Types)) {
                return this.event.Types.map((type) =>
                    typeof type.Name === 'string' ? type.Name.charAt(0).toUpperCase() + type.Name.slice(1) : ''
                );
            }
            return this.event?.Types || [];
        },
        amIcreator() {
            if (!this.meLocal || !this.event || !this.event.CreatedBy || !this.meLocal?.ID) return false;
            return this.event?.CreatedBy === this.meLocal?.ID;
        },
    },
    mounted() {
        // set amIattending and amIorganising
        this.amIattending = this.resolveAttendingState();
        this.amIorganising = this.isCurrentUserInCollection(this.event?.Organizers);
    },
    watch: {
        event: {
            handler() {
                // reevaluate amIattending and amIorganising
                this.amIattending = this.resolveAttendingState();
                this.amIorganising = this.isCurrentUserInCollection(this.event?.Organizers);
                this.amIIcreator = this.event?.CreatedBy === this.meLocal?.ID;
            },
            deep: true,
        },
    },
    methods: {
        get,
        uniqueId,
        desktopOnlyClass(display = 'block') {
            return this.useMobileFullLayout ? 'd-none' : `d-none d-md-${display}`;
        },
        mobileOnlyClass(display = 'block') {
            return this.useMobileFullLayout ? `d-${display}` : `d-${display} d-md-none`;
        },
        // Event feeds may either keep raw participant IDs or replace them with profile objects.
        isCurrentUserInCollection(collection) {
            if (!Array.isArray(collection) || !this.meLocal?.ID) {
                return false;
            }

            return collection.some((entry) => {
                if (typeof entry === 'string') {
                    return entry === this.meLocal.ID;
                }

                return entry?.ID === this.meLocal.ID;
            });
        },
        resolveAttendingState() {
            return Boolean(this.event?.Attend) || this.isCurrentUserInCollection(this.event?.Participants);
        },
        attendEvent(event) {
            if (!this.meLocal) return;

            this.$emit('attend', event);
            this.event.Participants
                ? this.event.Participants.unshift(this.meLocal)
                : (this.event.Participants = [this.meLocal]);

            axios({
                method: 'POST',
                url: '/event/participant',
                data: {
                    EventID: this.event.ID,
                    ParticipantID: this.meLocal.ID,
                },
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {})
                .catch((error) => {
                    this.$emit('error', { message: 'Failed to attend event', error });
                    this.event.Participants.shift();
                });
        },
    },
};
